'use strict';

module.exports = function () {
    $('.info-icon').on('mouseenter focusin', function () {
        var tooltip = $(this).find('.tooltip');
        var pos_left = $(this).offset().left + ($(this).outerWidth() / 2) - (tooltip.outerWidth() / 2);
        tooltip.css( 'visibility', 'hidden' );
        tooltip.removeClass('d-none');

        if (pos_left < 0) {
            tooltip.addClass('left');
        } else {
            tooltip.removeClass('left');
        }

        if (pos_left + tooltip.outerWidth() > $(window).width()) {
            tooltip.addClass('right');
        } else {
            tooltip.removeClass('right');
        }
        tooltip.css( 'visibility', 'visible' );

    });

    $('.info-icon').on('mouseleave focusout', function () {
        $(this).find('.tooltip').addClass('d-none');
    });
};